<template>
  <pui-dialog
    ref="dialog"
    :showCloseButton="false"
    @outsideClick="close"
    transition="slide-up"
    class="file-associate-dialog file-associate-dialog__root"
    noAutoClose
  >
    <template #dialog-action>
      <div class="dialog-action">
        <pui-button
          @click="close"
          class="file-associate-dialog__action-btn"
          variant="secondary"
          outline
        >
          {{ $t('dam.files.move.associate_dialog.buttons.cancel') }}
        </pui-button>
        <pui-button
          @click="onAssociate"
          :disabled="hasTasksInProgress"
          variant="primary"
          class="file-associate-dialog__action-btn"
        >
          <!-- This svg corresponds to mdi-timer-sand -->
          <!-- We need to use the svg instead of the font because we want -->
          <!-- to rotate it around its center (font messes up the center) -->
          <svg viewBox="0 0 24 24" class="has-tasks-in-progress-icon" v-if="hasTasksInProgress">
            <path
              d="M6,2H18V8H18V8L14,12L18,16V16H18V22H6V16H6V16L10,12L6,8V8H6V2M16,16.5L12,12.5L8,16.5V20H16V16.5M12,11.5L16,7.5V4H8V7.5L12,11.5M10,6H14V6.75L12,8.75L10,6.75V6Z"
            />
          </svg>
          {{ $t('dam.files.move.associate_dialog.buttons.confirm') }}
        </pui-button>
      </div>
    </template>

    <template #title>
      <span class="file-associate-dialog__title">
        {{
          $tc('dam.files.move.associate_dialog.title', associateFiles.length, {
            count: associateFiles.length,
          })
        }}
      </span>
    </template>

    <template #default>
      <pui-flex
        class="file-associate-dialog__content"
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <i18n
          v-if="hasTasksInProgress"
          path="dam.files.move.associate_dialog.wait_for_tasks"
          class="file-associate-dialog__message wait-for-tasks"
        ></i18n>
        <i18n path="dam.files.move.associate_dialog.message" class="file-associate-dialog__message">
          <template #count>
            {{ associateFiles.length }}
          </template>
          <template #targetFolder>
            <span class="target-folder">{{ piivoTranslate(targetFolder) }}</span>
          </template>
        </i18n>
      </pui-flex>
    </template>
  </pui-dialog>
</template>

<script>
import Vue from 'vue';

import services from '../../../../../core/services';
import { FileUpdateManager } from '../../../services/fileUpdateManager';
import { FileTaskStatus } from '../../../constants/file';
import { getDamService } from '../../../services';

export default {
  data() {
    return {
      // ASSOCIATE
      associateFiles: [],
      targetFolder: null,
    };
  },
  computed: {
    /**
     * @returns {boolean} if any of the files to associate have tasks
     * in progress
     */
    hasTasksInProgress() {
      return getDamService('fileTasks')
        .getCurrentFilesTasks(this.associateFiles.map(f => f.itemId))
        .some(t => t.data.state() === FileTaskStatus.IN_PROGRESS);
    },
  },
  methods: {
    piivoTranslate(value) {
      return Vue.filter('piivoTranslate')(value);
    },
    // DIALOG
    /**
     * Opens the dialog
     *
     * @returns {void}
     */
    open(files, targetFolder) {
      this.associateFiles = files;
      this.targetFolder = targetFolder;

      this.$refs.dialog.open();
    },
    /**
     * Closes the dialog and resets state
     *
     * @returns {void}
     */
    close() {
      this.$refs.dialog.close();

      this.associateFiles = [];
      this.targetFolder = null;
    },
    // ASSOCIATE
    /**
     * Associates the files to the target folder
     *
     * @returns {void}
     */
    async onAssociate() {
      const associateFileIds = this.associateFiles.map(file => file.itemId);
      const associate = [
        {
          fileIds: associateFileIds,
          folderIds: [this.targetFolder.itemId],
        },
      ];
      // Since close clears state, close only once we initialized the data
      // to send
      this.close();

      try {
        await FileUpdateManager.updateFiles(
          { fileIds: [], attributes: [] },
          associate,
          [],
          null,
          null
        );
      } catch (err) {
        console.error(err);
        services.getService('alerts').alertError(this.$t('dam.files.update.alert.error'));
      }
    },
  },
};
</script>
